import { Injectable } from "@angular/core";
import { BroadcastMessage } from "src/app/shared/general/constants";

@Injectable({
  providedIn: "root",
})
export class CommunicationService {
  private channel: BroadcastChannel | undefined;

  constructor() {
    if (typeof BroadcastChannel !== "undefined") {
      this.channel = new BroadcastChannel("bluChannel");
    }
  }

  sendMessage(message: BroadcastMessage): void {
    this.channel?.postMessage(message);
  }

  subscribeToMessages(callback: (message: BroadcastMessage) => void): void {
    if (this.channel) {
      this.channel.onmessage = (event) => {
        callback(event.data);
      };
    }
  }

  closeChannel(): void {
    this.channel?.close();
  }
}
